module.exports = __webpack_public_path__ + "img/20200508_180620.48c7cfe0.jpg";